import React from "react";

/**
 * ENERLEFT logo v2 — proper "E" shape:
 * vertical spine + three horizontal bars, middle bar in neon yellow.
 *
 * @param {number} size - width of the logo in pixels (height = size * 43/30)
 * @param {"dark"|"light"} tone - on "light" the foreground rects are graphite
 */
export function Logo({ size = 30, tone = "dark", ariaHidden = true }) {
    const w = size;
    const h = Math.round((size * 43) / 30);
    const fg = tone === "light" ? "#181B20" : "#F1F0EC";
    return (
        <svg
            width={w}
            height={h}
            viewBox="0 0 56 80"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={ariaHidden}
            aria-label={ariaHidden ? undefined : "ENERLEFT logo"}
            data-testid="enerleft-logo"
            style={{ display: "block", flexShrink: 0 }}
        >
            <rect x="0" y="0"    width="13" height="80" fill={fg} />
            <rect x="0" y="0"    width="50" height="13" fill={fg} />
            <rect x="0" y="33.5" width="38" height="13" fill="#E5FF00" />
            <rect x="0" y="67"   width="56" height="13" fill={fg} />
        </svg>
    );
}

/**
 * Brand: logo + wordmark + tag, in either tone.
 */
export function Brand({ logoSize = 30, tone = "dark" }) {
    const isLight = tone === "light";
    return (
        <div className={isLight ? "lt-brand" : "el-brand"} data-testid="enerleft-wordmark" style={isLight ? { marginBottom: 0 } : undefined}>
            <Logo size={logoSize} tone={tone} />
            <div>
                <div className={isLight ? "lt-wm" : "el-wm"}>ENERLEFT</div>
                <div className={isLight ? "lt-tag" : "el-tag"}>FULL SERVICES</div>
            </div>
        </div>
    );
}

export default Logo;
